'use client';

import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { isEqual, cloneDeep, get, set } from 'lodash';

interface TagEditorContextProps {
    handleChange: any;
    editedAiGeneratedData: any;
    setEditedAiGeneratedData: any;
    originalAiGeneratedDataRef: any;
    modifiedFields: any;
    setModifiedFields: any;
    selectedDesignLifeStyleImageDetailsForEdit: any;
    setSelectedDesignLifeStyleImageDetailsForEdit: any;
}

const TagEditorContext = createContext<TagEditorContextProps | undefined>(undefined);

export const TagEditorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [selectedDesignLifeStyleImageDetailsForEdit, setSelectedDesignLifeStyleImageDetailsForEdit] = useState<any>(null);
    const [editedAiGeneratedData, setEditedAiGeneratedData] = useState<any>({});
    const originalAiGeneratedDataRef = useRef<any>({});
    const [modifiedFields, setModifiedFields] = useState<Record<string, boolean>>({});
    const handleChange = (path: string, value: any) => {
        setEditedAiGeneratedData((prev: any) => {
            const updated = cloneDeep(prev);
            set(updated, path, value);

            // Track field modification
            const originalValue = get(originalAiGeneratedDataRef.current, path);
            const isChanged = !isEqual(originalValue, value);
            setModifiedFields((prevFields) => ({ ...prevFields, [path]: isChanged }));

            return updated;
        });
    };
    return (
        <TagEditorContext.Provider value={{ selectedDesignLifeStyleImageDetailsForEdit, setSelectedDesignLifeStyleImageDetailsForEdit, modifiedFields, setModifiedFields, handleChange, setEditedAiGeneratedData, editedAiGeneratedData, originalAiGeneratedDataRef }}>
            {children}
        </TagEditorContext.Provider>
    );
};

export const useTagEditor = (): TagEditorContextProps => {
    const context = useContext(TagEditorContext);
    if (context === undefined) {
        throw new Error('useTagEditor must be used within a TagEditorProvider');
    }
    return context;
};
